var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { getOwner } from '@ember/application';
import Service, { inject as service } from '@ember/service';
import * as Sentry from '@sentry/ember';
const LOCALHOST_DEV_PORT = '5173';
const DEV_MODE_MANIFEST_PATH = '/api/dashboard-spa-manifest';
const PROD_MODE_MANIFEST_PATH = '/shared-react-mfe/api/dashboard-spa-manifest';
let SharedMfe = (_class = class SharedMfe extends Service {
  constructor(properties) {
    super(properties);
    _initializerDefineProperty(this, "environment", _descriptor, this);
    _defineProperty(this, "cachedManifest", undefined);
    _defineProperty(this, "useLocalMfes", false);
    this.checkUrlForLocalDevelopmentParam();
  }
  checkUrlForLocalDevelopmentParam() {
    const params = getOwner(this).lookup('dashboard-core:initial-search-params');
    if (params) {
      this.useLocalMfes = params['useLocal'] ?? params['uselocal'] ?? false;
    } else {
      // when called from the preloader, we need to check the URL directly as the
      // initial search params are not available in `dashboard-core:initial-search-params`
      const urlParams = new URLSearchParams(window.location.search);
      this.useLocalMfes = urlParams.get('useLocal') === 'true' || urlParams.get('uselocal') === 'true';
    }
  }
  resetManifest() {
    this.cachedManifest = undefined;
  }
  async getManifest(priority = 'high') {
    if (!this.cachedManifest) {
      this.cachedManifest = await this.loadManifest(priority);
      if (this.cachedManifest.usingLocal) {
        this.renderBadge('Loading SMFE from localhost', 'use-local-smfe-badge');
      } else if (this.cachedManifest.usingPreviewBuild) {
        this.renderBadge('Loading SMFE from preview build', 'use-preview-build-smfe-badge');
      }
    }
    return this.cachedManifest;
  }
  renderBadge(badgeText, className) {
    const div = document.createElement('div');
    div.textContent = badgeText;
    div.style.color = 'red';
    div.classList.add(className);
    const container = document.querySelector('#messenger-host')?.shadowRoot?.querySelector('.fixed-badges');
    if (container) {
      container.appendChild(div);
    }
  }
  async preloadApp(signal) {
    const {
      manifest
    } = await this.getManifest('low');
    const modulesToPreload = manifest.moduleList;
    try {
      const promises = modulesToPreload.map(async moduleToPreload => {
        const response = await fetch(`${manifest.cdnOrigin}/${moduleToPreload}`, {
          signal,
          priority: 'low'
        });
        if (!response.ok) {
          throw new Error(`Failed to fetch module ${moduleToPreload} w/ status ${response.status}`);
        }
        return response;
      });
      await Promise.all(promises);
    } catch (e) {
      if (!signal.aborted) {
        Sentry.captureException(e);
      }
    }
  }
  getPreviewQueryParam() {
    const params = getOwner(this).lookup('dashboard-core:initial-search-params');
    return params ? params['preview'] :
    // when called from the preloader, we need to check the URL directly as the
    // initial search params are not available in `dashboard-core:initial-search-params`
    new URLSearchParams(window.location.search).get('preview');
  }
  async getStagingManifest(priority) {
    const preview = this.getPreviewQueryParam();
    const queryParams = preview ? `?preview=${preview}` : '';
    const manifest = await this.fetchManifest(`https://app.squareupstaging.com${PROD_MODE_MANIFEST_PATH}${queryParams}`, true, priority);
    return {
      manifest,
      usingLocal: false,
      usingPreviewBuild: Boolean(preview)
    };
  }
  async loadManifest(priority) {
    const {
      isProduction,
      isSandbox,
      isStaging
    } = this.environment;
    if (isStaging && this.useLocalMfes) {
      // see if we can load the local version to use by default, if it fails
      // fall back to loading the staging version
      const manifest = await this.fetchManifest(`http://localhost:${LOCALHOST_DEV_PORT}${DEV_MODE_MANIFEST_PATH}`, false, priority);
      return {
        manifest,
        usingLocal: true,
        usingPreviewBuild: false
      };
    }
    if (isProduction || isSandbox) {
      const manifest = await this.fetchManifest(`https://app.squareup.com${PROD_MODE_MANIFEST_PATH}`, true, priority);
      return {
        manifest,
        usingLocal: false,
        usingPreviewBuild: false
      };
    }
    if (isStaging) {
      return this.getStagingManifest(priority);
    }
    try {
      // see if we can load the local version to use by default, if it fails
      // fall back to loading the staging version
      const manifest = await this.fetchManifest(`http://localhost:${LOCALHOST_DEV_PORT}${DEV_MODE_MANIFEST_PATH}`, false, priority);
      return {
        manifest,
        usingLocal: true,
        usingPreviewBuild: false
      };
    } catch {
      return this.getStagingManifest(priority);
    }
  }
  async fetchManifest(manifestEndpoint, log = true, priority) {
    const response = await fetch(manifestEndpoint, {
      priority
    }).then(res => {
      if (res.ok) {
        return res.json();
      }
      throw new Error(`Failed to load manifest: ${res.status}`);
    }).catch(e => {
      if (log) {
        Sentry.captureException(e);
      }
      throw e;
    });
    const {
      app
    } = response;
    return app;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SharedMfe as default };